import React, { useEffect } from 'react';
import {
  makeStyles,
  BottomNavigation,
  BottomNavigationAction,
  Badge,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@material-ui/core';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import ViewAgendaOutlinedIcon from '@material-ui/icons/ViewAgendaOutlined';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import TouchAppOutlinedIcon from '@material-ui/icons/TouchAppOutlined';
import LinkIcon from '@material-ui/icons/Link';
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { useHistory, useLocation } from 'react-router-dom';
import { storeContext } from '../provider/Provider';

/*
 * initial Sidebar template that only display background and logo
 * StaticSidebar and Login components are customizing Sidebar component */

const drawerWidth = 260;

export { drawerWidth };

const useStyles = makeStyles(() => ({
  navbar: {
    position: 'fixed',
    bottom: 0,
    zIndex: 3,
    transition: 'box-shadow 0.5s ease-in-out',
    boxShadow: '0px -7px 5px 0px rgba(0,0,0,0.05)',
    '& .MuiBottomNavigationAction-root:last-child>span': {
      transition: 'transform 0.5s ease-in-out',
      transform: 'rotate(0deg)',
    },
    '&.open': {
      boxShadow: '0px -0px 5px 0px rgba(0,0,0,0.05)',
      '& .MuiBottomNavigationAction-root:last-child>span': {
        transform: 'rotate(180deg)',
      },
    },
    width: '100%',
    '& .MuiBottomNavigationAction-root': {
      minWidth: 0,
    },
  },
  navbarOpen: {
    position: 'fixed',
    bottom: 0,
    zIndex: 1,
    width: '100%',
    '& .MuiBottomNavigationAction-root': {
      minWidth: 0,
    },
    '& .MuiBottomNavigationAction-root:last-child>span': {
      transition: 'transform 0.5s ease-in-out',
      transform: 'rotate(0deg)',
    },
    transition: 'z-index 0.50s ease-in-out, opacity 0.5s ease-in-out',
    opacity: 0,
    '&.open': {
      opacity: 1,
      zIndex: 4,
      '& .MuiBottomNavigationAction-root:last-child>span': {
        transform: 'rotate(180deg)',
      },
    },
  },
  themeBadge: {
    backgroundColor: '#D81F27',
    color: 'white',
  },
  openArrow: {
    background: '#00B4E0',
    borderRadius: 20,
    height: 30,
    width: 30,
    '& svg': {
      height: '100%',
      color: 'white',
    },
  },
  bigNav: {
    display: 'block',
    bottom: 0,
    position: 'fixed',
    background: 'white',
    height: '0%',
    transition: 'height 0.5s, box-shadow 0.5s ease-in-out',
    boxShadow: '0px -0px 5px 0px rgba(0,0,0,0.05)',
    '&.open': {
      height: 'calc(100% - 120px)',
      boxShadow: '0px -7px 5px 0px rgba(0,0,0,0.05)',
    },
    zIndex: 3,
    width: '100%',
    '&>div': {
      display: 'block',
      margin: 'auto',
      width: '60%',
      marginTop: 40,
    },
  },
  greyColorCustomizer: {
    color: '#C2CFE0',
  },
  blueColorCustomizer: {
    color: '#00B5E2',
  },
  listItemFocused: {
    color: '#00B5E2',
  },
  list: {
    '& .MuiTypography-root': {
      fontSize: '1.3rem',
    },
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const history = useHistory();
  let currentPage = useLocation().pathname.replace('/', '');

  useEffect(() => {
    if (currentPage === '') {
      setValue(0);
    }
    if (currentPage === 'leads' || currentPage.includes('leads') || currentPage.includes('calls')) {
      setValue(1);
    }
    if (currentPage === 'content' || currentPage.includes('content')) {
      setValue(2);
    }
    if (currentPage === 'analytics' || currentPage.includes('keywords')) {
      setValue(3);
    }
    if (currentPage === 'paid-media') {
      setValue(4);
    }
    if (currentPage === 'digital-pr') {
      setValue(5);
    }
    if (currentPage === 'support') {
      setValue(6);
    }
    if (currentPage === 'settings') {
      setValue(7);
    }
    history.listen((location) => {
      currentPage = location.pathname.replace('/', '');
      if (currentPage === '') {
        setValue(0);
      }
      if (
        currentPage === 'leads' ||
        currentPage.includes('leads') ||
        currentPage.includes('calls')
      ) {
        setValue(1);
      }
      if (currentPage === 'content' || currentPage.includes('content')) {
        setValue(2);
      }
      if (currentPage === 'analytics' || currentPage.includes('keywords')) {
        setValue(3);
      }
      if (currentPage === 'paid-media') {
        setValue(4);
      }
      if (currentPage === 'digital-pr') {
        setValue(5);
      }
      if (currentPage === 'support') {
        setValue(6);
      }
      if (currentPage === 'settings') {
        setValue(7);
      }
    });
  }, [value]);
  const { state } = React.useContext(storeContext);

  const handleOpenNav = () => {
    const bigNav = document.getElementById('bigNav');
    bigNav.classList.toggle('open');
    const mobileTitle = document.getElementById('mobileTitle');
    const topNavButton = document.getElementById('topNavButton');
    const topNav = document.getElementById('mobileTopNav');
    const root = document.getElementById('root');
    root.parentElement.classList.toggle('no-scroll');
    if (window.scrollY > 65 && mobileTitle) {
      const clonedTitle = document.getElementById('mobileTitleClone');
      const clonedTopNav = document.getElementById('mobileTopNavClone');
      const clonedTopButton = document.getElementById('topNavButtonClone');
      if (clonedTitle) {
        clonedTitle.style.height = '0';
        clonedTitle.style.padding = '0';
        clonedTitle.firstChild.style.opacity = 0;
        clonedTopButton.classList.add('removed');
        clonedTopNav.classList.remove('open');
        setTimeout(() => {
          clonedTitle.remove();
          clonedTopButton.remove();
          clonedTopNav.remove();
        }, 500);
      } else {
        const clone = mobileTitle.cloneNode(true);
        const topNavClone = topNav.cloneNode(true);
        const topNavButtonClone = topNavButton.cloneNode(true);
        topNavButtonClone.addEventListener('click', () => {
          document.getElementById('mobileTopNavClone').classList.toggle('open');
        });
        clone.id = 'mobileTitleClone';
        clone.classList.toggle('openedNav');
        topNavButtonClone.id = 'topNavButtonClone';
        topNavButtonClone.classList.add('navOpen');
        topNavClone.id = 'mobileTopNavClone';
        topNavClone.classList.add('navOpen');
        root.firstChild.insertBefore(clone, bigNav);
        root.firstChild.insertBefore(topNavClone, clone);
        root.firstChild.insertBefore(topNavButtonClone, topNavClone);
        setTimeout(() => {
          clone.style.padding = '40px 0';
          clone.style.height = '50px';
          clone.firstChild.style.opacity = 1;
        }, 100);
      }
    }
    document.getElementById('navbar').classList.toggle('open');
    document.getElementById('navbarOpen').classList.toggle('open');
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <BottomNavigation className={classes.bigNav} id="bigNav">
        <div id="navList">
          {state.auth.user.role === 'content_only' ? (
            <>
              <List className={classes.list}>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/content');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {state.content.contentCountByType['Topics for Review'] ||
                    state.content.contentCountByType['Content for Review'] ||
                    state.content.contentCountByType['Revised Content for Review'] ? (
                      <Badge
                        badgeContent={
                          state.content.contentCountByType['Topics for Review'] +
                          state.content.contentCountByType['Content for Review'] + 
                          state.content.contentCountByType['Revised Content for Review']
                        }
                        classes={{ badge: classes.themeBadge }}
                      >
                        {currentPage.includes('content') ? (
                          <MailOutlinedIcon className={classes.blueColorCustomizer} />
                        ) : (
                          <MailOutlinedIcon className={classes.greyColorCustomizer} />
                        )}
                      </Badge>
                    ) : (
                      <>
                        {currentPage.includes('content') ? (
                          <MailOutlinedIcon className={classes.blueColorCustomizer} />
                        ) : (
                          <MailOutlinedIcon className={classes.greyColorCustomizer} />
                        )}
                      </>
                    )}
                  </ListItemIcon>
                  {currentPage.includes('content') ? (
                    <ListItemText primary="Content" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Content" />
                  )}
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/support');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'support' ? (
                      <ChatBubbleOutlineOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <ChatBubbleOutlineOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'support' ? (
                    <ListItemText primary="Support" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Support" />
                  )}
                </ListItem>
              </List>
              <Divider className={classes.greyColorCustomizer} />
              <List className={classes.list}>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/settings');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'settings' ? (
                      <MoreHorizIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <MoreHorizIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'settings' ? (
                    <ListItemText primary="Settings" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Settings" />
                  )}
                </ListItem>
              </List>
            </>
          ) : (
            <>
              <List className={classes.list}>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === '' ? (
                      <DashboardOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <DashboardOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === '' ? (
                    <ListItemText primary="Overview" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Overview" />
                  )}
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/campaign-updates');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === '' ? (
                      <DashboardOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <DashboardOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === '' ? (
                    <ListItemText primary="Campaign Updates" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Campaign Updates" />
                  )}
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/leads');
                    }, 350);
                  }}
                  aria-label="leads button"
                >
                  <ListItemIcon>
                    {currentPage === 'leads' ||
                    currentPage === 'leads/full-view' ||
                    currentPage === 'calls/full-view' ? (
                      <ViewAgendaOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <ViewAgendaOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'leads' ||
                  currentPage === 'leads/full-view' ||
                  currentPage === 'calls/full-view' ? (
                    <ListItemText primary="Leads" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Leads" />
                  )}
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/content');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {state.content.contentCountByType['Topics for Review'] ||
                    state.content.contentCountByType['Content for Review'] ||
                    state.content.contentCountByType['Revised Content for Review'] ? (
                      <Badge
                        badgeContent={
                          state.content.contentCountByType['Topics for Review'] +
                          state.content.contentCountByType['Content for Review'] + 
                          state.content.contentCountByType['Revised Content for Review']
                        }
                        classes={{ badge: classes.themeBadge }}
                      >
                        {currentPage.includes('content') ? (
                          <MailOutlinedIcon className={classes.blueColorCustomizer} />
                        ) : (
                          <MailOutlinedIcon className={classes.greyColorCustomizer} />
                        )}
                      </Badge>
                    ) : (
                      <>
                        {currentPage.includes('content') ? (
                          <MailOutlinedIcon className={classes.blueColorCustomizer} />
                        ) : (
                          <MailOutlinedIcon className={classes.greyColorCustomizer} />
                        )}
                      </>
                    )}
                  </ListItemIcon>
                  {currentPage.includes('content') ? (
                    <ListItemText primary="Content" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Content" />
                  )}
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/analytics');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'analytics' || currentPage === 'keywords/full-view' ? (
                      <PersonOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <PersonOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'analytics' || currentPage === 'keywords/full-view' ? (
                    <ListItemText primary="Analytics" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Analytics" />
                  )}
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/paid-media');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'paid-media' ? (
                      <TouchAppOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <TouchAppOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'paid-media' ? (
                    <ListItemText primary="Paid Media" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Paid Media" />
                  )}
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/digital-pr');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'digital-pr' ? (
                      <LinkIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <LinkIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'digital-pr' ? (
                    <ListItemText primary="Digital PR" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Digital PR" />
                  )}
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/support');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'support' ? (
                      <ChatBubbleOutlineOutlinedIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <ChatBubbleOutlineOutlinedIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'support' ? (
                    <ListItemText primary="Support" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Support" />
                  )}
                </ListItem>
              </List>
              <Divider className={classes.greyColorCustomizer} />
              <List className={classes.list}>
                <ListItem
                  button
                  onClick={() => {
                    handleOpenNav();
                    setTimeout(() => {
                      history.push('/settings');
                    }, 350);
                  }}
                >
                  <ListItemIcon>
                    {currentPage === 'settings' ? (
                      <MoreHorizIcon className={classes.blueColorCustomizer} />
                    ) : (
                      <MoreHorizIcon className={classes.greyColorCustomizer} />
                    )}
                  </ListItemIcon>
                  {currentPage === 'settings' ? (
                    <ListItemText primary="Settings" className={classes.listItemFocused} />
                  ) : (
                    <ListItemText primary="Settings" />
                  )}
                </ListItem>
              </List>
            </>
          )}
        </div>
      </BottomNavigation>

      {state.auth.user.role === 'content_only' ? (
        <BottomNavigation onChange={handleChange} className={classes.navbar} id="navbar">
          <BottomNavigationAction
            onClick={() => {
              history.push('/content');
            }}
            className={`${currentPage.includes('content') ? ' Mui-selected' : ''}`}
            icon={
              state.content.contentCountByType['Topics for Review'] ||
              state.content.contentCountByType['Content for Review'] ||
              state.content.contentCountByType['Revised Content for Review'] ? (
                <Badge
                  badgeContent={
                    state.content.contentCountByType['Topics for Review'] +
                    state.content.contentCountByType['Content for Review'] + 
                    state.content.contentCountByType['Revised Content for Review']
                  }
                  classes={{ badge: classes.themeBadge }}
                >
                  <MailOutlinedIcon />
                </Badge> ) : (
                  <MailOutlinedIcon />
                )
            }
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/support');
            }}
            className={`${currentPage.includes('support') ? ' Mui-selected' : ''}`}
            icon={<ChatBubbleOutlineOutlinedIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/settings');
            }}
            className={`${currentPage.includes('settings') ? ' Mui-selected' : ''}`}
            icon={<MoreHorizIcon />}
          />
          <BottomNavigationAction
            onClick={handleOpenNav}
            icon={
              <span className={classes.openArrow}>
                <KeyboardArrowUpRoundedIcon />
              </span>
            }
          />
        </BottomNavigation>
      ) : (
        <BottomNavigation
          value={value}
          onChange={handleChange}
          className={classes.navbar}
          id="navbar"
        >
          <BottomNavigationAction
            onClick={() => {
              history.push('/');
            }}
            icon={<DashboardOutlinedIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/leads');
            }}
            icon={<ViewAgendaOutlinedIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/content');
            }}
            icon={
              state.content.contentCountByType['Topics for Review'] ||
              state.content.contentCountByType['Content for Review'] ||
              state.content.contentCountByType['Revised Content for Review'] ? (
                <Badge
                  badgeContent={
                    state.content.contentCountByType['Topics for Review'] +
                    state.content.contentCountByType['Content for Review'] + 
                    state.content.contentCountByType['Revised Content for Review']
                  }
                  classes={{ badge: classes.themeBadge }}
                >
                  <MailOutlinedIcon />
                </Badge> ) : (
                  <MailOutlinedIcon />
                )
            }
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/analytics');
            }}
            icon={<PersonOutlinedIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/paid-media');
            }}
            icon={<TouchAppOutlinedIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/digital-pr');
            }}
            icon={<LinkIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/support');
            }}
            icon={<ChatBubbleOutlineOutlinedIcon />}
          />
          <BottomNavigationAction
            onClick={() => {
              history.push('/settings');
            }}
            icon={<MoreHorizIcon />}
          />
          <BottomNavigationAction
            onClick={handleOpenNav}
            icon={
              <span className={classes.openArrow}>
                <KeyboardArrowUpRoundedIcon />
              </span>
            }
          />
        </BottomNavigation>
      )}
      <BottomNavigation
        value={value}
        onChange={handleChange}
        className={classes.navbarOpen}
        id="navbarOpen"
      >
        <BottomNavigationAction />
        <BottomNavigationAction />
        <BottomNavigationAction />
        <BottomNavigationAction />
        <BottomNavigationAction />
        <BottomNavigationAction />
        <BottomNavigationAction />
        <BottomNavigationAction
          onClick={handleOpenNav}
          icon={
            <span className={classes.openArrow}>
              <KeyboardArrowUpRoundedIcon />
            </span>
          }
        />
      </BottomNavigation>
    </>
  );
};

export default Navbar;
